import React from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Info, CheckCircle } from 'lucide-react';

const BulkUploadGuide: React.FC = () => {
  return (
    <div className="space-y-4">
      <Alert>
        <Info className="h-4 w-4" />
        <AlertDescription>
          <div className="space-y-2">
            <p className="font-medium">How to use Bulk Upload:</p>
            <ol className="list-decimal list-inside space-y-1 text-sm">
              <li>Download the CSV template using the button below</li>
              <li>Fill in student information (name and email are required)</li>
              <li>For multiple courses, separate course IDs with commas</li>
              <li>Upload the completed CSV file</li>
              <li>Review validation results and click "Create Students"</li>
            </ol>
          </div>
        </AlertDescription>
      </Alert>

      <Alert className="border-green-200 bg-green-50">
        <CheckCircle className="h-4 w-4 text-green-600" />
        <AlertDescription>
          <div className="space-y-2">
            <p className="font-medium text-green-900">CSV Format:</p>
            <ul className="list-disc list-inside space-y-1 text-sm text-green-800">
              <li><strong>name</strong> - Student's full name (required)</li>
              <li><strong>email</strong> - Student's email address (required)</li>
              <li><strong>phone</strong> - Phone number (optional)</li>
              <li><strong>department</strong> - Department name (optional)</li>
              <li><strong>courses</strong> - Course IDs separated by commas (optional)</li>
            </ul>
          </div>
        </AlertDescription>
      </Alert>
    </div>
  );
};

export default BulkUploadGuide;
